enum EstadosModalSalidaDevolucion {
    CERRADO = 'CERRADO',
    CREACION = 'CREACION',
    EDICION = 'EDICION',
    VISUALIZACION = 'VISUALIZACION',
}

export { EstadosModalSalidaDevolucion };
